import { processSummaryData } from '../../utils/dataUtils';
import { useGetTimelineSummary } from '../../utils/queryHooks';
import { useMemo } from 'react';

export const useTimelineSummary = ({ viewerId, clientId, interval }) => {
  const {
    data,
    isFetchedAfterMount,
    isFetching: summaryLoading,
    error: summaryError,
    isError,
    refetch,
  } = useGetTimelineSummary(viewerId, interval, clientId);

  const summaryDataRes = useMemo(
    () =>
      processSummaryData(
        data ?? {
          userInfoData: [],
          eventSummaryData: [],
        },
      ),
    [data],
  );

  return {
    refetchSummary: refetch,
    isFetchedAfterMount,
    summaryData: summaryDataRes,
    summaryLoading,
    summaryError: isError ? summaryError : undefined,
  };
};
